import React from "react"; // eslint-disable-line no-unused-vars
import { DragSource, DropTarget } from "react-dnd";
import { compose } from "react-apollo";
import move from "../../img/move.svg";

const ElementSource = {
  beginDrag(props) {
    return {
      id: props.id,
      index: props.index,
    };
  },
  endDrag(props) {},
};

const ElementTarget = {
  drop(props, monitor, component) {
    props.saveNewOrder();
  },
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Determine rectangle on screen
    const hoverBoundingRect = component.node.getBoundingClientRect();

    // Get vertical middle
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

    // Determine mouse position
    const clientOffset = monitor.getClientOffset();

    // Get pixels to the top
    const hoverClientY = clientOffset.y - hoverBoundingRect.top;

    // Only perform the move when the mouse has crossed half of the items height
    // When dragging downwards, only move when the cursor is below 50%
    // When dragging upwards, only move when the cursor is above 50%

    // Dragging downwards
    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return;
    }

    // Dragging upwards
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return;
    }

    // Time to actually perform the action
    props.moveDoc(dragIndex, hoverIndex);

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex;
  },
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
    connectDragPreview: connect.dragPreview(),
  };
}

function targetCollect(connect) {
  return {
    connectDropTarget: connect.dropTarget(),
  };
}

class DocContextMenuElement extends React.Component {
  constructor(props) { //eslint-disable-line
    super(props);
  }

  handleChangeDoc = () => {
    this.props.handleChangeDoc(this.props.doc);
  };

  render() {
    const {
      connectDragSource,
      isDragging,
      connectDragPreview,
      connectDropTarget,
    } = this.props;
    if (isDragging) {
      //change someting
    }
    return (
      connectDropTarget &&
      connectDragSource &&
      connectDragPreview(
        connectDropTarget(
          <a
            ref={(node) => (this.node = node)}
            className={`dropdown-item ${
              this.props.doc.id === this.props.selectedDoctorId
                ? " is-active"
                : ""
            }`}
            key={this.props.doc.id}
            onClick={this.handleChangeDoc}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingRight: "1rem",
            }}
          >
            {this.props.doc.name}
            {connectDragSource(
              <span
                style={{
                  height: 16,
                  width: 16,
                }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                className="grabbable"
              >
                <figure className="image is-16x16">
                  <img alt="move" src={move} />
                </figure>
              </span>
            )}
          </a>
        )
      )
    );

    /*
  return (
      <a
        className={`dropdown-item ${
          this.props.doc.id === this.props.selectedDoctorId ? " is-active" : ""
        }`}
        key={this.props.doc.id}
        onClick={() => this.props.handleChangeDoc(this.props.doc)}
      >
        {this.props.doc.name}
      </a>
    );*/
  }
}

export default compose(
  DragSource("order", ElementSource, collect),
  DropTarget("order", ElementTarget, targetCollect)
)(DocContextMenuElement);



// WEBPACK FOOTER //
// ./src/components/utilities/DocContextMenuElement.js